import React from 'react';
import { NormalLayout, MySessions } from 'components';


/**
 * 所有課程頁面
 */

export const MySessionsPage = () => {
  return (
    <NormalLayout>
      <MySessions />
    </NormalLayout>
  );
};
